import React from 'react';

import { Box, Button } from '@mui/material';

type Props = {
  onDownload?: () => void;
};

export const ActionBuyDownload: React.FC<Props> = ({ onDownload }) => {
  return (
    <Box>
      <Button variant='contained' fullWidth sx={{ padding: '16px' }} onClick={onDownload}>
        Download
      </Button>
    </Box>
  );
};
